import { useEffect, useState } from 'react';

// We want to populate the CHECKOUT_NAME in the funnels with a string representing the product chosen by the user.
// In order to not fire undefined or intermediate values to dataLayer, we debounce the productNumber.
// This is a simple approach so we don't violate React rules of hooks by calling tracking hooks conditionally.
export function useDebouncedProductId<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
}
